<script>
  import { useBackendVersion } from "../../../hooks/useBackendVersion.js";

  const frontendVersion = "__MY_SCHEDULE_VERSION__"
  const backendVersion = useBackendVersion()
</script>

<div class="root">
  <img src="/icon-192.png" height="100" alt="logo" />
  <div style="flex: 1">
    <div class="title-container">
      <div class="title">Asprova My Schedule ver. {frontendVersion}</div>
      <div class="caption">with Asprova WS ver. {$backendVersion ?? "..."}</div>
    </div>
  </div>
</div>

<style>
  .root {
    display: flex;
    justify-content: space-between;
    gap: 2rem;
    align-items: center;
  }
  .title-container {
    display: flex;
    gap: 1rem;
    align-items: baseline;
  }
  .title {
    font-size: 1.5rem;
    font-weight: bold
  }
</style>
